import gql from "graphql-tag"

export const USER_GROUPS_COMPANIES_FRAG = gql`
  fragment UserGroupsCompaniesFrag on BaseUserType {
    companies {
      id
      kind
      name
      codename
    }
    groups {
      id
      name
      category {
        id
        codename
      }
    }
  }
`
